import { render, staticRenderFns } from "./VehicleTypesList.vue?vue&type=template&id=71cd196e&scoped=true&"
import script from "./VehicleTypesList.vue?vue&type=script&lang=js&"
export * from "./VehicleTypesList.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTypesList.vue?vue&type=style&index=0&id=71cd196e&lang=scss&scoped=true&"
import style1 from "./VehicleTypesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cd196e",
  null
  
)

export default component.exports